// extracted by mini-css-extract-plugin
export default {"img":"iHUKPoVsZ-LqS9QdGnLfpg=="};